/* eslint-disable no-underscore-dangle */
import { AutoboardVehicle } from '../../../src/app/@shared-types/vehicle';
import { Mileage } from '../../../src/app/@shared-types/vehicle/vehicle';
import ObjectService from '../../../src/app/shared/services/object';
import { SalesAPIService } from '../../../shared/api/sales-api.service';
import { DeepPartial } from '../../../src/app/@shared-types';
import { VehicleFormComponentExitFunction } from '../../../src/app/@types/vehicle';
import { UsersService } from '../../../shared/users/users.service';
import { EMileageSource } from '../../../src/app/@shared-types/vehicle/enums';

export class MileageFormController {
  private exit!: (data: VehicleFormComponentExitFunction) => void;

  private salesApiService: SalesAPIService;

  private usersService: UsersService;

  private objectService: ObjectService;

  public vehicle!: AutoboardVehicle;

  public sending = false;

  public updateData: {
    mileage: Mileage,
  } | null = null;

  /* @ngInject */
  constructor(
    salesApiService: SalesAPIService,
    objectService: ObjectService,
    usersService: UsersService,
  ) {
    this.salesApiService = salesApiService;
    this.objectService = objectService;
    this.usersService = usersService;
  }

  public $onInit = (): void => {
    this.updateData = {
      mileage: this.objectService.deepCopy(this.vehicle.vehicleData.mileage),
    };
  };

  public formTransmission = async (): Promise<void> => {
    this.sending = true;

    const changedVals: DeepPartial<AutoboardVehicle> = {
      _id: this.vehicle._id,
      vehicleData: {
        mileage: {
          total: this.updateData?.mileage.total,
          lastUpdate: new Date(),
          updateUser: this.usersService.currentUserId(),
          updateSource: EMileageSource.Manual,
        },
      },
    };

    await this.salesApiService.putVehicle(changedVals);

    return this.exit({});
  };
}
